/**
 * i18n Provider
 *
 * Internationalization provider for React Admin.
 * Supports multiple languages with automatic browser detection
 * and locale persistence in localStorage.
 */

import polyglotI18nProvider from 'ra-i18n-polyglot';
import en from '@/i18n/en/index';
import es from '@/i18n/es/index';

export type SupportedLocale = 'es' | 'en';

const messages: Record<string, any> = { en, es };

export const availableLocales = [
  { locale: 'en', name: 'English' },
  { locale: 'es', name: 'Español' },
];

const getSavedLocale = (): SupportedLocale => {
  const saved = localStorage.getItem('locale');
  if (saved === 'es' || saved === 'en') return saved;
  const browserLocale = navigator.language.split('-')[0];
  if (browserLocale === 'es' || browserLocale === 'en') return browserLocale;
  return 'es';
};

export const i18nProvider = polyglotI18nProvider(
  (locale) => {
    if (locale !== localStorage.getItem('locale')) {
      localStorage.setItem('locale', locale);
    }
    return messages[locale] || messages.en;
  },
  getSavedLocale(),
  availableLocales,
);

export default i18nProvider;
